import { ImpersonatingSnackbar } from "components/navbars";
import React from "react";
import { useSelector } from "react-redux";

export default function ImpersonatingBar() {
  const impersonating = useSelector((state) => state.profile.impersonating);
  return impersonating ? <ImpersonatingSnackbar /> : null;
}
